import { render } from "./ULeft.vue?vue&type=template&id=bc639a20&scoped=true"
import script from "./ULeft.vue?vue&type=script&lang=js"
export * from "./ULeft.vue?vue&type=script&lang=js"

import "./ULeft.vue?vue&type=style&index=0&id=bc639a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc639a20"]])

export default __exports__